<script>
import Skeleton from 'dashboard/components-next/skeleton/Skeleton.vue';

export default {
  components: { Skeleton },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    toolTip: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2 items-start justify-center min-w-[10rem]">
    <span
      class="inline-flex items-center gap-1 text-xs font-medium text-n-slate-11"
    >
      {{ label }}
      <fluent-icon
        v-tooltip.right="toolTip"
        size="14"
        icon="information"
        type="outline"
        class="flex flex-shrink-0 text-sm font-normal sm:font-medium text-n-slate-10"
      />
    </span>
    <Skeleton v-if="isLoading" variant="block" class="w-12 h-6 mb-0.5" />

    <span v-else class="text-2xl font-semibold tabular-nums text-n-slate-12">
      {{ value }}
    </span>
  </div>
</template>
